import { useQuery } from '@apollo/client';
import { useAuthStore } from '@/store/useAuthStore';
import { GetUserResponse } from '@/api/types/user.types';
import { GET_USER } from '@/api/queries/user.queries';

export function useCurrentUser() {
  const userInfo = useAuthStore(state => state.userInfo);

  const { data: userDetailedInfo, loading } = useQuery<GetUserResponse>(
    GET_USER,
    {
      errorPolicy: 'all',
    }
  );

  return {
    loading,
    user: {
      id: userInfo.legacyId,
      name: userInfo.name,
      phone: userInfo.authenticationPhone,
      avatarUrl:
        userDetailedInfo?.currentUser?.photo?.url ?? userInfo.shop?.logo?.url,
      walletBalance: userDetailedInfo?.currentUser?.walletBalance,
      isAppleGooglePayEnabled:
        userDetailedInfo?.currentUser?.isAppleGooglePayEnabled,
      paymentMethods: userDetailedInfo?.currentUser?.paymentMethods,
    },
  };
}
